var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { align: "center" } },
    [
      _c(
        "v-flex",
        { attrs: { md10: "" } },
        [
          _c(
            "v-card",
            { staticClass: "rounded-card" },
            [
              _c(
                "v-form",
                {
                  ref: "form",
                  staticClass: "col-md-12",
                  attrs: { "lazy-validation": "" }
                },
                [
                  _c(
                    "v-container",
                    { attrs: { "grid-list-md": "", "text-xs-center": "" } },
                    [
                      _c(
                        "FormFieldsContainer",
                        { attrs: { titulo: "Mensaje" } },
                        [
                          _vm._t("prependHtmlTemplate"),
                          _c(
                            "v-layout",
                            { attrs: { row: "", wrap: "" } },
                            [
                              _c(
                                "v-flex",
                                { attrs: { md12: "" } },
                                [
                                  _c("v-textarea", {
                                    attrs: {
                                      solo: "",
                                      rows: 3,
                                      "error-messages": _vm.errors.collect(
                                        _vm.formFields.mensaje.id
                                      ),
                                      "data-vv-name": _vm.formFields.mensaje.id,
                                      "no-resize": _vm.modoVer,
                                      disabled: _vm.modoVer
                                    },
                                    on: { change: _vm.handleChangeMensaje },
                                    model: {
                                      value: _vm.formFields.mensaje.value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formFields.mensaje,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression: "formFields.mensaje.value"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        2
                      ),
                      _c(
                        "FormFieldsContainer",
                        { attrs: { titulo: "HTML Template" } },
                        [
                          _vm._t("prependHtmlTemplate"),
                          _c(
                            "v-layout",
                            { attrs: { row: "", wrap: "" } },
                            [
                              _c(
                                "v-flex",
                                { attrs: { md12: "" } },
                                [
                                  _c("CodeView", {
                                    attrs: {
                                      language: "text/html",
                                      readOnly: _vm.modoVer
                                    },
                                    on: { blur: _vm.handleBlurHtml },
                                    model: {
                                      value: _vm.formFields.html.value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formFields.html,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression: "formFields.html.value"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        2
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }